import { render, staticRenderFns } from "./InstructionParameterObject.vue?vue&type=template&id=bd139f96&"
import script from "./InstructionParameterObject.vue?vue&type=script&lang=js&"
export * from "./InstructionParameterObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports